// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { SsoCallbackCard } from '#components/entities/users/sso/sso-callback-card.tsx'
import type { SsoCallbackSearch } from '#components/entities/users/sso/sso-callback-state.ts'

// The router JSON-parses search values, so an all-digit value arrives as a number.
const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value ? value : typeof value === 'number' ? String(value) : undefined

/** Microsoft's redirect URI: it returns here with `code` and `state`, or with `error` on a cancel or refusal. */
export const Route = createFileRoute('/_authentication/sso/microsoft/callback')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SsoCallbackSearch => ({
    code: text(search.code),
    state: text(search.state),
    error: text(search.error),
  }),
})

function RouteComponent() {
  return <SsoCallbackCard provider="microsoft" search={Route.useSearch()} />
}
